module.exports = __webpack_public_path__ + "img/akazlogonewnew.1b418427.png";